import { render } from "./FilterForm.vue?vue&type=template&id=36c4c801&ts=true"
import script from "./FilterForm.vue?vue&type=script&lang=ts"
export * from "./FilterForm.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__